import React from 'react'
import Service from './service.component'

const ProductService = () => {
  return (
    <div className='flex w-full justify-center items-center'>
      <div className="flex max-w-7xl w-full">
        <div className="flex flex-col w-full">
          {/* <h1 className="text-2xl lg:text-4xl font-bold text-black">Product Services</h1> */}
          <div className='flex items-center justify-center w-full'>
            <Service />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductService